import { usePlan } from '../lib/plan';

// "This week" toggle. Lives on the catalog card and the recipe page.
export function PlanButton({ slug, size = 'md' }: { slug: string; size?: 'md' | 'lg' }) {
  const plan = usePlan();
  const on = plan.has(slug);
  const h = size === 'lg' ? 'h-11 px-5 text-[0.9rem]' : 'h-9 px-3.5 text-[0.8rem]';
  return (
    <button
      type="button"
      aria-pressed={on}
      onClick={() => (on ? plan.remove(slug) : plan.add(slug))}
      className={`inline-flex items-center gap-1.5 rounded-full border font-sans font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink ${h} ${
        on ? 'border-freeze bg-freeze text-paper' : 'border-line bg-card text-ink-soft hover:border-ink-soft hover:text-ink'
      }`}
    >
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {on ? <path d="M5 13l4 4L19 7" /> : <path d="M12 5v14M5 12h14" />}
      </svg>
      {on ? 'This week' : 'Add to this week'}
    </button>
  );
}
